import React from 'react';
import ReactDOM from 'react-dom/client';
import './stylesheets/index.css';
import App from './App';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './components/ErrorFallback';
import { BrowserRouter } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { installErrorReporter, reportError } from './utils/errorReporter';

// Vor dem Rendern einhängen, damit auch Fehler beim ersten Aufbau erfasst werden.
installErrorReporter();

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Render-Fehler fängt die ErrorBoundary ab — window.onerror sieht sie
          nicht, deshalb werden sie hier zusätzlich gemeldet. */}
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error, info) =>
          reportError({
            kind: 'react',
            message: error?.message || String(error),
            stack: `${error?.stack || ''}\n--- componentStack ---${info?.componentStack || ''}`,
          })
        }
      >
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
)
